<template>
  <div class="model"  :style="{ backgroundColor: `${bColor}80` }">
    <div class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">
      {{ title }}
    </div>
    <div class="modelBg">
      <div class="main">
        <div class="title" :style="{color:tColor}">完成采摘任务<br/>瓜分{{bonusShowAmount}}元奖池</div>
        <img class="prizeIcon" src="https://assets.rurushishi.com/activies/activityCenter/lightup/prizeIcon.png"/>
        <div class="bonusShowAmount"><span>{{bonusShowAmount}}</span>元</div>
        <div class="tip">
          当前已有<span :style="{color:bColor}">{{completedNum || 0}}</span>人成功完成种树任务<br/>
          参与奖池瓜分
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "bColor","tColor", "bgColor", "title", "textColor",'bonusShowAmount','completedNum'],
  data() {
    return {
      ranking: [],
      showMore: false,
    };
  },
  created() {},
  methods: {
    clickMore() {
      this.ranking = this.data;
      this.showMore = false;
    },
  },
  computed: {
    bgStyle() {
      return {
        background: `linear-gradient(180deg, ${this.bgColor} 0%, ${this.bgColor}00 100%)`,
      };
    },
  },
  watch: {
    // bgColor: {
    //   handler(val) {
    //     this.$nextTick(() => {
    //       let name = ["first", "second", "third"];
    //       name.map((item) => {
    //         this.$refs[
    //           item
    //         ].style = `background: linear-gradient(180deg, ${val} 0%, ${val}00 100%);`;
    //       });
    //     });
    //   },
    //   deep: true,
    // },
    data: {
      handler(val) {
        this.$nextTick(() => {
          this.ranking = val.slice(0, 10);
          if (val.length > 10) {
            this.showMore = true;
          }
        });
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.model {
  width: 351px;
  margin: 32px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.1);
  padding:10px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  .modelTitle {
    position: absolute;
    margin-top: -10px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    z-index: 1;
    font-weight: 600;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 12px 12px;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;
    .main{
      margin: 50px 7px 19px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
      }
      .prizeIcon{
        margin-top:16px;
        width: 230px;
      }
      .bonusShowAmount{
        font-family: 'DIN Alternate';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        text-align: center;
        color: #FA541C;
        margin-top:8px;
        span{
          font-weight: 700;
          font-size: 36px;
          line-height: 36px;
        }
      }
      .tip{
        margin-top:4px;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        text-align: center;
        color: #333333;
        span{
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
